import { Step } from "react-joyride";
import { VisibilityStates } from "../../types/VisibilityStates";

export const tourStepsYourCollections = (
  visibilityStates: VisibilityStates,
): Step[] => {
  const steps: Step[] = [
    {
      target: ".your-collections-page",
      content:
        "Your Collections is the main place to create, open, edit, and delete practice sets. Each card is one collection.",
      disableBeacon: true,
    },
    {
      target: ".search-collections-input",
      content:
        "Type part of a name to find a collection quickly, then press Search or Enter.",
    },
    {
      target: ".collections-filters",
      content:
        "Filter by category and change the sort. Custom Order lets you drag cards. Other sorts group collections by category.",
    },
    {
      target: "#myMasteryStageSelect",
      content:
        "My stage is your current learning group: Beginner, Intermediate, or Advanced. Pick one to only see collections tagged for that group. Choose Show all to see every collection. Switch whenever you feel ready — decks stay in their tag; you move between groups.",
    },
    {
      target: ".collection-card",
      content:
        "The dashed card starts a new collection. Solid cards are collections you already have.",
      ...(visibilityStates.isCollectionCardVisible ? { isOpen: true } : {}),
    },
    {
      target: ".start-collection-button",
      content:
        "Start opens session settings: speed, shuffle, timer, and interactive mode. Then the items play full screen.",
      ...(visibilityStates.isStartCollectionButtonVisible
        ? { isOpen: true }
        : {}),
    },
    {
      target: ".edit-collection-button",
      content:
        "Edit lets you rename items, reorder them, or remove items from this collection.",
      ...(visibilityStates.isEditCollectionButtonVisible
        ? { isOpen: true }
        : {}),
    },
    {
      target: ".delete-collection-button",
      content:
        "Delete removes the collection. Session reports tied to it are removed too.",
      ...(visibilityStates.isDeleteCollectionButtonVisible
        ? { isOpen: true }
        : {}),
    },
  ];

  return steps.filter((step) => {
    const target = step.target as string;
    if (target === ".collection-card")
      return visibilityStates.isCollectionCardVisible;
    if (target === ".start-collection-button")
      return visibilityStates.isStartCollectionButtonVisible;
    if (target === ".edit-collection-button")
      return visibilityStates.isEditCollectionButtonVisible;
    if (target === ".delete-collection-button")
      return visibilityStates.isDeleteCollectionButtonVisible;
    return true;
  });
};
